import React, { lazy, Suspense } from "react";
import { Routes, Route } from "react-router-dom";
import RequisitionList from "./scenes/reports/RequisitionList/RequisitionList";
import { OrderList } from "./scenes/reports/OrderList/OrderList";
import  ReturnList  from "./scenes/reports/ReturnList/ReturnList";
import { PaymentsList } from "./scenes/reports/PaymentList/PaymentList";
import { InvoiceList } from "./scenes/reports/InvoiceList/InvoiceList";
import { VendorList } from "./scenes/reports/VendorList/VendorList";
import Loader from "./components/Loader/Loader";
import Unauthorized from "./components/unauthorized/Unauthorized";
import ProductMarginReport from "./scenes/reports/ProductMarginReport/ProductMarginReport";
import InventoryUpdates from "./scenes/Invoice/InventoryUpdates";

const Login = lazy(() => import("./scenes/login/Login"));
const ProtectedRoute = lazy(() =>
  import("./components/protectedRoutes/ProtectedRoute")
);
const PurchaseRequisition = lazy(() =>
  import("./scenes/purchaseRequisition/PurchaseRequisition")
);
const Quotation = lazy(() => import("./scenes/purchaseRequisition/Quotation"));
const MasterList = lazy(() =>
  import("./scenes/purchaseRequisition/MasterList")
);
const PurchaseOrder = lazy(() =>
  import("./scenes/purchaseRequisition/PurchaseOrder")
);
const AddInvoice = lazy(() => import("./scenes/Invoice/addInvoice"));
const Billing = lazy(() => import("./scenes/sales/Billing"));
const AllBills = lazy(() => import("./scenes/sales/AllBills"));
const PharmacyInventory = lazy(() =>
  import("./scenes/Invoice/PharmacyInventory")
);
const Payments = lazy(() =>
  import("./scenes/purchaseRequisition/PaymentHistory")
);
const AddEmployee = lazy(() => import("./scenes/Employee/AddEmployee"));
const EmployeeList = lazy(() => import("./scenes/Employee/EmployeeList"));
const StockUpdates = lazy(() =>
  import("./scenes/Invoice/InventoryUpdates")
);
const Sales = lazy(() => import("./scenes/sales/Sales"));

function App() {
  return (
    <Suspense fallback={<Loader open={true} />}>
      <Routes>
        <Route path="/:id" element={<Login />} />
        <Route
          path="/purchase"
          element={<ProtectedRoute element={<Unauthorized />} />}
        >
          <Route index element={<PurchaseRequisition />} />
          <Route path="purchaseRequisition" element={<PurchaseRequisition />} />
          <Route path="quotation" element={<Quotation />} />
          <Route path="bestPricingOrder" element={<MasterList />} />
          <Route path="purchaseorder" element={<PurchaseOrder />} />
          <Route path="addPayment" element={<Payments />} />
        </Route>
        <Route
          path="/inventory"
          element={<ProtectedRoute element={<Unauthorized />} />}
        >
          <Route index element={<AddInvoice />} />
          <Route path="addInvoice" element={<AddInvoice />} />
          <Route path="PharmacyInventory" element={<PharmacyInventory />} />
          <Route path="inventoryUpdates" element={<StockUpdates />} />
        </Route>
        <Route
          path="/sales"
          element={<ProtectedRoute element={<Unauthorized />} />}
        >
          <Route index element={<Sales />} />
          <Route path="billing" element={<Sales />} />
          <Route path="allBills" element={<AllBills />} />
        </Route>
        <Route
          path="/reports"
          element={<ProtectedRoute element={<Unauthorized />} />}
        >
          <Route index element={<RequisitionList />} />{" "}
          {/* Added index route */}
          <Route path="requisitionList" element={<RequisitionList />} />{" "}
          {/* Case corrected */}
          <Route path="purchaseOrderList" element={<OrderList />} />{" "}
          {/* Case corrected */}
          <Route path="returnList" element={<ReturnList />} />{" "}
          {/* Case corrected */}
          <Route path="paymentsList" element={<PaymentsList />} />{" "}
          {/* Case corrected */}
          <Route path="invoiceList" element={<InvoiceList />} />{" "}
          {/* Case corrected */}
          <Route path="vendorList" element={<VendorList />} />{" "}
          {/* Case corrected */}
          <Route
            path="productMarginReport"
            element={<ProductMarginReport />}
          />{" "}
        </Route>
        <Route
          path="/employee"
          element={<ProtectedRoute element={<Unauthorized />} />}
        >
          <Route path="employeeList" element={<EmployeeList />} />
          <Route path="addEmployee" element={<AddEmployee />} />
        </Route>
        <Route
          path="/employee"
          element={<ProtectedRoute element={<Unauthorized />} />}
        >
          <Route path="employeeList" element={<EmployeeList />} />
          <Route path="addEmployee" element={<AddEmployee />} />
        </Route>
      </Routes>
    </Suspense>
  );
}

export default App;
